module.exports = __webpack_public_path__ + "media/images/errors/500-776b4f4e50b079b0b7353801cbc71219.png";